import { render, staticRenderFns } from "./PointOfSale.vue?vue&type=template&id=3d435dcc&scoped=true&"
import script from "./PointOfSale.vue?vue&type=script&lang=js&"
export * from "./PointOfSale.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PointOfSale.vue?vue&type=style&index=1&id=3d435dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d435dcc",
  null
  
)

export default component.exports